import React from "react";

const SImpleCardShimmer = () => {
  return (
    <div className="max-w-full rounded-xl p-4 border ">
      {/* Top row */}
      <div className="flex justify-between items-start gap-4">
        <div className="flex flex-col gap-2 flex-1">
          {/* Title */}
          <div className="h-4 w-3/4 rounded-md shimmer" />

          {/* Amount */}
          <div className="h-5 w-1/3 rounded-md shimmer" />
        </div>

        {/* Button shimmer */}
        <div className="h-7 w-20 rounded-full shimmer" />
      </div>

      {/* Divider */}
      <div className="my-3 h-px shimmer opacity-40" />

      {/* Bottom value */}
      <div className="h-5 w-1/4 rounded-md shimmer" />
    </div>
  );
};

export default SImpleCardShimmer;
